// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__1TgzI","adaptiveModal":"Modal_adaptiveModal__Kg3NM","modal":"Modal_modal__1vwov","close":"Modal_close__2EfR5"};